import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getTheme,
  getIsMobile,
  getSeoCanonical,
  getSeoTitle,
  getSeoDescription,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  hasFirstTimeFlag,
  FirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';
import { isSourceImageVertical } from '@wix/da-shared-react/pkg/DeviationViews/Dumbo/Image/_helpers';
import { AppState } from '../../../types/store';
import { appLoaded, pathChange } from '../../actions/app';
import { isSectionLoading, getActiveSection } from '../../selectors/sections';
import { getCoverDeviation } from '../../selectors/deviations';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../selectors/users';

import App from './App';

const mapStateToProps = (state: AppState) => {
  const coverDeviation = getCoverDeviation(state);
  const profileOwnerUser = getProfileOwnerUser(state);
  const isOwner = isCurrentUserProfileOwner(state);
  const pageTitle = getSeoTitle(state);
  const pageDescription = getSeoDescription(state);
  return {
    pageTitle,
    pageDescription,
    activeSection: getActiveSection(state),
    seoCanonical: getSeoCanonical(state),
    isMobile: getIsMobile(state),
    isOwner,
    profileOwnerId: profileOwnerUser.userId,
    isSectionLoading: isSectionLoading(state),
    theme: getTheme(state),
    environment: state.environment.type,
    hasVerticalCoverImage:
      coverDeviation && isSourceImageVertical(coverDeviation),
    showProfileHeroAid:
      isOwner &&
      !coverDeviation &&
      hasFirstTimeFlag(state, FirstTimeFlag.ProfileHeroAidNotClosed),
    showProfileEditAid:
      isOwner && hasFirstTimeFlag(state, FirstTimeFlag.ProfileEditAidNotClosed),
    isReducedHero: flagEnabled(state, 'profile_reduced_hero'),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      onAppRendered: appLoaded,
      onPathChange: pathChange,
    }
  )(App)
);
